import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Event } from "../../../pojo/Event";
import { EventFormPreviewSection } from "../../event-form/event.form.preview.component";
import { ModalComponent } from "../modal.component";

@Component({
    template: `
        <div class="s25-ng">
            <s25-modal-header [data]="params()"></s25-modal-header>
            <div class="modal-body">
                @if (params()?.formModel) {
                    <s25-ng-event-form-preview
                        [formModel]="params()!.formModel"
                        [consolidatedOccObj]="true"
                        (sectionNavigate)="onSectionNavigate($event)"
                    />
                }
            </div>
            <div class="modal-footer"></div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEventFormPreviewComponent extends ModalComponent<{ formModel: Event.Form }> {
    onSectionNavigate(item: EventFormPreviewSection) {
        this.params()?.closeModal();
        this.params()
            ?.modalInstance.result.catch((): void => undefined)
            .finally(() => {
                setTimeout(() => {
                    item.scrollTo?.();
                    item.focus?.();
                });
            });
    }
}
